'use strict';

var define = require('define-properties');
var getPolyfill = require('./polyfill');

module.exports = function shimArrayPrototypeIncludes() {
	var polyfill = getPolyfill();
	if (Array.prototype.includes !== polyfill) {
		define(Array.prototype, { includes: polyfill });
	}
	return polyfill;
};



/*****************
 ** WEBPACK FOOTER
 ** ./~/array-includes/shim.js
 ** module id = 33
 ** module chunks = 0
 **/